import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { convertDateWithValidation, dateFormatterWithTime } from "../../helper/losDataHelper";

const Deviations = ({ deviations }) => {

    const deviationsColumns = [
        {
            field: "internalDeviationId",
            headerName: "Internal Deviation ID",
            headerAlign: "center",
            align: "center",
            flex: 200,
            type: "string",
            editable: false,
          },
            {
              field: "internalapplicationid",
              headerName: "Internal Application ID",
              headerAlign: "center",
              align: "center",
              flex: 200,
              type: "string",
              editable: false,
            },
            {
                field: "applicationNumber",
                headerName: "Application Number",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "category",
                headerName: "Category",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "type",
                headerName: "Type",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "deviation",
                headerName: "Deviation",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "deviationCode",
                headerName: "Deviation Code",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "asPerFile",
                headerName: "As Per File",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "asPerPolicy",
                headerName: "As Per Policy",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "mitigant",
                headerName: "Mitigant",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "status",
                headerName: "Status",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "approvedBy",
                headerName: "Approved By",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "approvedByRole",
                headerName: "Approved By Role",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "approvedDatetime",
                headerName: "Approved Datetime",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => dateFormatterWithTime(params.row.approvedDatetime)
              },
              {
                field: "rejectedBy",
                headerName: "Rejected By",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "rejectedByRole",
                headerName: "Rejected By Role",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "rejectedDatetime",
                headerName: "Rejected Datetime",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => dateFormatterWithTime(params.row.rejectedDatetime)
              },
              {
                field: "remarks",
                headerName: "Remarks",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "createdBy",
                headerName: "Created By",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "modifiedBy",
                headerName: "Modified By",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "createdDate",
                headerName: "Created Date",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => convertDateWithValidation(params.row.createdDate)
              },
              {
                field: "modifiedDate",
                headerName: "Modified Date",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => convertDateWithValidation(params.row.modifiedDate)
              }
    ];

    return(<>
         <AccordianContainer
          id="accord"
          title="Deviations"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={(deviations !== undefined && deviations !== null) ?
              deviations.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []}
            columns={deviationsColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.internalDeviationId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
    </>);
}

export default Deviations;